import React from 'react'
import styled from 'styled-components'

// Styling
import { defaultColor } from '../../styles/colors'
import { AnyColor } from '../../common/models/colors'
import { applyTextStyle, applyCustomTextStyle } from '../../styles/typography'

interface IProps {
  size: 'small' | 'medium' | 'large' | 'xLarge'
  color?: AnyColor
  textColor?: AnyColor
  amount: number | React.ReactNode
  className?: string
}

interface ITagProps extends IProps {
  color: AnyColor
}

const AmountTag = (props: IProps) => {
  const color = props.color ? props.color : defaultColor
  return (
    <StyledAmountTag
      className={props.className}
      color={color}
      textColor={props.textColor}
      size={props.size}
    >
      {props.amount}
    </StyledAmountTag>
  )
}

const bigVariantTextStyles = {
  mobile: { fontSize: 24, lineHeight: 32, fontWeight: 600 },
}

export const StyledAmountTag = styled.strong<
  Pick<ITagProps, 'color' | 'size' | 'textColor'>
>`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  height: ${(props) =>
    props.size === 'xLarge'
      ? '48px'
      : props.size === 'large'
      ? '32px'
      : props.size === 'medium'
      ? '24px'
      : '16px'};
  padding: ${(props) =>
    props.size === 'xLarge' || props.size === 'large'
      ? '8px'
      : props.size === 'medium'
      ? '4px 8px'
      : '0px 4px'};
  border-radius: ${({ size }) => (size === 'small' ? 4 : 8)}px;
  background-color: ${({ color, theme }) => theme.colors[color]};
  color: ${({ textColor, theme }) => theme.colors[textColor || 'lightest']};
  ${(props) =>
    props.size === 'xLarge'
      ? applyCustomTextStyle(bigVariantTextStyles)
      : props.size === 'small'
      ? applyTextStyle('label')
      : applyTextStyle('labelHeavy')}
  text-align: center;
`

export default AmountTag
